// extracted by mini-css-extract-plugin
module.exports = {"skipButton":"SkipToNextBlock_skipButton__2dDKS"};